import { render, staticRenderFns } from "./V3NamaSpesifikasiBarang.vue?vue&type=template&id=3738c35c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports